import Games from './Games';
import {store} from '../../store/store'
import axios from "axios";

export default class Aiguille extends Games {


    rules(productScan) {

        let user = store.getters['getUser']
        console.log(user)
        return user

        //check combinaison
        //founded = user.event_mask.id === productScan.id

        //check Mask/Animal
        //founded = user.event_mask.mask.id === productScan.mask.id

        //check Texture/couleur
        //founded = user.event_mask.texture.id === productScan.texture.id

        //check ScanList
        //axios.post('user/'+user.id+'/scanlist/search',{user_scanned_id:productScan.user}).then(res=>{
        //
        //            //let condition = {founded:founded,know:res.data.isScanned}
        // }
        // })


    }

    point(conditions) {
        let points = super.points(conditions);
        //Active Success notification
        //store.commit('setSuccess',{name:'Aiguille Game Success',message:'Vous avez trouvé votre cible',points:points }

    }
}